import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.ideaValue = null;
        this.textarea = this.el.querySelector('textarea');
        this.submitButton = this.el.querySelector('.c-button.-submit-idea');
        this.submitButtonSidebar = document.querySelector('.elearning-ideas-sidebar_button');
        this.modal = document.querySelector('.c-modal');
        this.closeButton = this.modal.querySelector('.c-modal_close');
        this.overlay = this.modal.querySelector('.c-modal_overlay');
        this.messageField = this.modal.querySelector('textarea[name="message"]');

        this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.openIdeasModal();
        });
        
        if (this.submitButtonSidebar) {
            this.submitButtonSidebar.addEventListener('click', (e) => {
                e.preventDefault();
                this.openIdeasModal();
            });
        }

        this.closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.closeModal();
        });

        this.overlay.addEventListener('click', (e) => {
            e.preventDefault();
            this.closeModal();
        });
    }

    openIdeasModal() {
        if (this.textarea) {
            this.ideaValue = this.textarea.value;
        }

        this.call('stop', 'Scroll');
        this.modal.classList.add('-opened');

        if (this.textarea) {
            this.messageField.value = this.ideaValue;
            this.ideaValue = null;
            this.textarea.value = '';
        }
    }

    closeModal() {
        this.modal.classList.remove('-opened');
        this.call('start', 'Scroll');
    }
}
